import { includes, map } from 'lodash';

export const decorateRecipe = recipe => {
  const hasCategory = key => includes(recipe.categories, key);

  return recipe
    ? {
        ...recipe,
        isVegetarian: hasCategory('Vegetarian'),
        isFreezable: hasCategory('Freezable'),
        isLactoseFree: hasCategory('Lactose free'),
        isGlutenFree: hasCategory('Gluten free'),
        isMarinatingRequired: hasCategory('Marinating required'),
        isDiabeticFriendly: hasCategory('Diabetic friendly'),
        isLowFodmap: hasCategory('Low FODMAP'),
      }
    : undefined;
};

export const decorateRecipes = recipes => map(recipes, decorateRecipe);



// WEBPACK FOOTER //
// ./src/decorators/decorateRecipes.js